<template>
	<div class="md-layout">
		<div class="md-layout-item">
			<md-card>
				<div class="md-layout-item">
					<md-field>
						<md-icon>search</md-icon>
						<md-input type="text" name="search" v-model="searchValue" placeholder="Buscar"></md-input>
					</md-field>
				</div>
			</md-card>
			<md-card v-if="loading">
				<md-card-content style="margin: 0 auto">
					<circle2 background="#999" color="#0C4DA2"></circle2>
				</md-card-content>
			</md-card>
			<template v-else>
				<md-card v-if="results.length">
					<md-card-header>
						<template v-if="enableImport">
							<input type="file" :id="`import-${instanceId}`" class="file-input" @change="importCsv($event.target.files)" />
							<circle2 v-if="importing" background="#999" color="#0C4DA2" size="20px" stroke="3px"></circle2>
							<md-button v-else class="md-accent md-sm" @click="chooseCsvFile()"><md-icon>cloud_upload</md-icon>Importar CSV</md-button>
							<span v-if="csvModel && !importing" style="cursor: pointer" title="Baixar modelo" @click="downloadCsvModel()"><md-icon>help_outline</md-icon></span>
						</template>
						<md-button @click="exportSearch()" style="float: right" class="md-accent md-sm"><md-icon>cloud_download</md-icon>Exportar</md-button>
					</md-card-header>
					<md-card-content>
						<md-table :value="results" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder" :md-sort-fn="customSort" class="paginated-table table-striped table-hover" @md-selected="rowSelected">
							<md-table-row slot="md-table-row" slot-scope="{ item }" @click="openEntity ? openEntity(item) : () => {}" :style="{ cursor: openEntity ? 'pointer' : 'auto' }" :md-selectable="onSelect ? 'multiple' : undefined">
								<md-table-cell v-for="(field, fieldIndex) in displayFields" :key="fieldIndex" :md-label="field.name" :md-sort-by="field.key">
									<template v-if="editingRows.find(row => row.id === item.id)">
										<form-field :fieldKey="field.key" v-bind="{ schema, entity: editingRows.find(row => row.id === item.id) }" :contentOnly="true" class="row-form-field"></form-field>
									</template>
									<template v-else>
										<span v-if="field.kind == 'picture-url'" class="image-holder">
											<img :src=" item[field.key]" alt>
										</span>
										<span v-else-if="field.kind === 'select'">
											{{ field.options.find(option => option.value === item[field.key]).name }}
										</span>
										<div v-else-if="field.kind === 'color'" class="color-block" :style="{ 'background-color': item[field.key] }"></div>
										<span v-else-if="field.kind === 'date'">{{ item[field.key] | formatDate }}</span>
										<span v-else-if="field.kind === 'datetime'">{{ item[field.key] | formatDateTime }}</span>
										<span v-else-if="field.kind === 'money'">{{ item[field.key] | formatMoney }}</span>
										<span v-else-if="field.kind === 'file'">
											<a v-if="item[field.key]" :href="item[field.key]" target="_blank"><md-icon style="cursor: pointer; color: #0C4DA2">get_app</md-icon></a>
											<div v-else class="upload-column">
												<input type="file" :id="`upload-${field.key}-${item.id}`" class="file-input" @change="uploadFile($event.target.files, item, field)" />
												<label v-if="!uploading" :for="`upload-${field.key}-${item.id}`"><md-icon style="cursor: pointer; color: #0C4DA2">cloud_upload</md-icon></label>
												<circle2 v-if="uploading" background="#999" color="#0C4DA2" size="20px" stroke="3px"></circle2>
											</div>
										</span>
										<span v-else>{{ item[field.key] instanceof Array ? item[field.key].map(subEntity => subEntity.name).join(", ") : item[field.key] }}</span>
									</template>
									<span v-if="field.kind === 'actions'">
										<circle2 v-if="actionsLoading" background="#999" color="#0C4DA2" size="20px" stroke="3px" style="display: inline-block; margin-right: 10px"></circle2>
										<template v-else-if="!editingRows.find(row => row.id === item.id)">
											<div v-if="editable" style="display: inline" title="Editar" @click="editingRows.push({ ...item })">
												<md-icon style="cursor: pointer; color: #0C4DA2">edit</md-icon>
											</div>
											<div v-for="action in field.actions" :key="action.name" :title="action.name" style="display: inline" @click="executeAction($event, action.action, item)">
												<md-icon :style="{ color: action.color, cursor: 'pointer' }">{{ action.icon }}</md-icon>
											</div>
										</template>
										<template v-else>
											<div style="display: inline" title="Salvar" @click="editSave(item)">
												<md-icon style="cursor: pointer; color: #0C4DA2">done</md-icon>
											</div>
											<div style="display: inline" title="Cancelar" @click="editClear(item)">
												<md-icon style="cursor: pointer">clear</md-icon>
											</div>
										</template>
									</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</md-card-content>
					<md-card-actions md-alignment="space-between">
						<div>
							<p class="card-category">Mostrando {{ (pagination.currentPage - 1) * pagination.limit + 1 }} a {{ (pagination.currentPage - 1) * pagination.limit + results.length }} de {{ pagination.total }}</p>
						</div>
						<pagination class="pagination-no-border pagination-accent" v-model="pagination.currentPage" :per-page="pagination.limit" :total="pagination.total"></pagination>
					</md-card-actions>
				</md-card>
				<md-card v-else>
					<md-card-content style="text-align: center">
						<template v-if="error"><md-icon>warning</md-icon><br>{{ error }}</template>
						<template v-else>Nenhum resultado encontrado</template>
					</md-card-content>
				</md-card>
			</template>
		</div>
	</div>
</template>

<script>
import { Circle2 } from'vue-loading-spinner';
import debounce from 'debounce';
import XLSX from 'xlsx';
import { format, parseISO } from 'date-fns';
import * as fileDownload from 'js-file-download';
import { Pagination } from "@/components";
import EspressoAux from "@/components/Espresso/EspressoAux";

import FormField from './FormField.vue';
import { uploadFile } from "@/models/request";

export default {
	name: "PaginatedSearch",
	props: {
		entityModel: Object,
		searchFilter: { type: Object, default: () => {} },
		searchActions: { type: Array, default: () => [] },
		openEntity: Function,
		joinKeys: { type: Array, default: () => [] }, // fields to join
		fieldKeys: Array, // override displayInResults property fom entity description
		onSelect: Function,
		editable: { type: Boolean, default: false },
		enableImport: { type: Boolean, default: false },
		csvModel: String,
		initialSort: { type: Object, default: undefined },
	},
	components: {
		Pagination,
		Circle2,
		FormField,
	},
	data() {
		return {
			schema: [],
			searchValue: "",
			currentSortOrder: "asc",
			currentSort: "_", // placeholder until model is loaded
			results: [],
			pagination: {
				total: 0,
				currentPage: 1,
				limit: 10,
				lastPage: 0,
			},
			loading: 0,
			error: "",
			uploading: false,
			firstSort: true,
			editingRows: [],
			actionsLoading: false,
			importing: false,
			instanceId: Math.random().toString().slice(2),
		};
	},
	computed: {
		currentPage() {
			return this.pagination.currentPage;
		},
		displayFields() {
			let fields = [];
			if (this.fieldKeys) {
				fields = this.fieldKeys.map(key => this.schema.find(field => field.key === key));
			} else if (this.schema) {
				fields = this.schema.filter(field => field.displayInResults);
			}
			if (this.$route.meta.permissionType === 'READ_WRITE' && (this.searchActions.length || this.editable)) {
				fields.push({ kind: 'actions', key: 'actions', name: 'Opções', actions: this.searchActions });
			}
			return fields;
		},
	},
	methods: {
		refresh() {
			this.executeSearch();
		},
		customSort() {
			if (this.firstSort) { // prevent infinite search loop
				this.firstSort = false;
			} else {
				this.executeSearch();
			}
		},
		async executeSearch() {
			if (this.currentSort === "_") { // do not search if model has not loaded
				return;
			}

			this.loading = true;

			const queryParameters = {
				page: this.pagination.currentPage || 1,
				limit: this.pagination.limit,
				sort: [{
					field: this.currentSort,
					order: this.currentSortOrder ? this.currentSortOrder.toUpperCase() : "ASC",
				}],
				search: {
					...this.searchFilter,
					$or: this.displayFields.filter(field => field && field.kind !== 'relation' && field.kind !== 'actions').map(field => ({
						[field.key]: {
							$cont: this.searchValue,
						},
					})),
				},
				join: this.joinKeys.map(key => ({ field: key })),
			};

			try {
				const response = await this.entityModel.search(queryParameters);
				this.results = response.data;
				this.pagination = {
					total: response.total,
					currentPage: response.page,
					lastPage: response.pageCount,
					limit: queryParameters.limit,
				};
				this.error = "";
			} catch (error) {
				this.error = "Erro ao carregar os dados. Verifique sua conexão com a internet.";
				console.error(error);
			}

			await new Promise(resolve => setTimeout(resolve, 300));
			this.loading = false;
			this.firstSort = true;
		},
		async exportSearch() {
			const queryParameters = {
				sort: [{
					field: this.currentSort,
					order: this.currentSortOrder ? this.currentSortOrder.toUpperCase() : "ASC",
				}],
				search: {
					...this.searchFilter,
					$or: this.displayFields.filter(field => field && field.kind !== 'relation' && field.kind !== 'actions').map(field => ({
						[field.key]: {
							$cont: this.searchValue,
						},
					})),
				},
				join: this.joinKeys.map(key => ({ field: key })),
			};
			const exportData = await this.entityModel.search(queryParameters, true);
			if (!exportData.length) {
				return;
			}
			const fieldsToExport = Object.keys(exportData[0]).map(fieldKey => this.schema.find(field => field.key === fieldKey)).filter(field => !!field);
			// troca nomes do cabeçalho e traduz selects
			const xlsData = exportData.map(row => fieldsToExport.reduce((processedRow, field) => ({
				...processedRow,
				[field.name]: field.kind === 'select' ?  field.options.find(option => option.value === row[field.key])?.name : row[field.key],
			}), {}))
			const exportWS = XLSX.utils.json_to_sheet(xlsData, fieldsToExport.map(field => field.name));
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, exportWS, 'Relatório');
			XLSX.writeFile(wb, 'relatorio.xlsx');
		},
		async uploadFile(files, item, field) {
			this.uploading = true;
			try {
				const { uuid, url } = await uploadFile(files[0]);
				await this.entityModel.update(item.id, { ...item, [field.key]: uuid });
				item[field.key] = url;
			} catch (error) {
				console.error(error);
				this.$toasted.error("Não foi possível enviar o arquivo. Tente novamente.");
			}
			this.uploading = false;
		},
		rowSelected(items) {
			if (this.onSelect) {
				this.onSelect(items);
			}
		},
		async editSave(item) {
			this.actionsLoading = true;
			try {
				const editedItem = this.editingRows.find(row => row.id === item.id);
				this.results[this.results.indexOf(item)] = await this.entityModel.update(item.id, editedItem);
				this.editClear(item);
			} catch (error) {
				console.error(error);
				this.$toasted.error("Não foi possível atualizar o registro.");
			}
			this.actionsLoading = false;
		},
		editClear(item) {
			this.editingRows.splice(this.editingRows.indexOf(item), 1);
		},
		async executeAction(event, action, item) {
			event.stopPropagation();
			this.actionsLoading = true;
			await action(item);
			this.actionsLoading = false;
		},
		chooseCsvFile() {
			document.getElementById(`import-${this.instanceId}`).click();
		},
		async importCsv(files) {
			if (!this.entityModel.importCsv) {
				this.$toasted.error("Importação não implementada");
				return;
			}
			this.importing = true;
			try {
				const text = await EspressoAux.readFileAsText(files[0]);
				const { affectedRows } = await this.entityModel.importCsv(text);
				this.$toasted.success(`Importação de ${affectedRows} registro(s) realizada com sucesso`);
				this.executeSearch();
			} catch (error) {
				console.error(error);
				this.$toasted.error("Não foi possível enviar o arquivo. Tente novamente.");
			}
			this.importing = false;
		},
		downloadCsvModel(files) {
			fileDownload(this.csvModel, 'modelo.csv');
		},
	},
	async mounted() {
		if (!this.entityModel) {
			throw Error("Entity model property is required");
		}

		this.loading = true;
		try {
			this.schema = await this.entityModel.getDescription();
			const hasInitialSort = this.initialSort !== undefined;
			const isValidInitialSort = hasInitialSort
				&& typeof this.initialSort === 'object'
				&& this.initialSort !== null
				&& typeof this.initialSort.field === 'string'
				&& this.initialSort.field.trim().length > 0
				&& ['asc', 'desc'].includes(this.initialSort.order);

			if (hasInitialSort && !isValidInitialSort) {
				throw Error("Invalid initialSort property");
			}

			if (isValidInitialSort) {
				this.currentSort = this.initialSort.field;
				this.currentSortOrder = this.initialSort.order;
			} else {
				const defaultSortField = this.schema.find(field => field.defaultSort && field.key.indexOf(".") < 0) || this.schema[0];
				this.currentSortOrder = ["asc", "desc"].includes(defaultSortField.defaultSort) ? defaultSortField.defaultSort : "asc";
				this.currentSort = defaultSortField.key;
			}

			this.executeSearch();
		} catch (error) {
			this.loading = false;
			throw error;
		}
	},
	watch: {
		currentPage() {
			this.executeSearch();
		},
		searchValue() {
			this.pagination.currentPage = 1;
			this.executeSearch();
		},
		searchFilter: {
			deep: true,
			handler(previousFilter, newFilter) {
				if (JSON.stringify(previousFilter) !== JSON.stringify(newFilter)) {
					this.pagination.currentPage = 1;
					this.executeSearch();
				}
			},
		},
	},
	created() {
		this.executeSearch = debounce(this.executeSearch, 300);
	},
	filters: {
		formatDateTime(value) {
			return value ? format(parseISO(value), "dd/MM/yyyy HH:mm") : "";
		},
		formatDate(value) {
			return value ? format(parseISO(value), "dd/MM/yyyy") : "";
		},
		formatMoney(value) {
			return value ? parseFloat(value)?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "";
		},
	},
};
</script>

<style lang="css">
	.md-card .md-card-actions {
		border: 0;
		margin-left: 20px;
		margin-right: 20px;
	}

	.paginated-table .md-table-head.md-sortable .md-table-sortable-icon {
		display: none;
	}

	.md-table-head-label {
		color: #555 !important;
		font-size: 0.9rem !important;
		font-weight: 800;
		padding-right: 0 !important;
	}

	.color-block {
		display: inline-block;
		height: 25px;
		width: 50px;
		border-radius: 5px;
		margin-top: 5px;
		margin-right: 5px;
	}

	.file-input {
		width: 0.1px;
		height: 0.1px;
		opacity: 0;
		overflow: hidden;
		position: absolute;
		z-index: -1;
	}
	.row-form-field .md-field {
		margin: 0;
	}
</style>
